import t from '@jetshop/intl';
import { Above } from '@jetshop/ui/Breakpoints';
import Drawer, { DrawerTarget, DrawerTrigger } from '@jetshop/ui/Modal/Drawer';
import React, { Fragment, useEffect, useState } from 'react';
import { styled } from 'linaria/react';
//import { ActiveFilters } from './ActiveFilters';
import { BooleanFilters } from './BooleanFilters';
import FilterDrawer from './Mobile/FilterDrawer';
import { ListFilters } from './ListFilters';
//import { MultiListFilters } from './MultiListFilters';
import { RangeFilters } from './RangeFilters';
import ListSorting from './ListSorting';
import { theme } from '../../Theming/Theming';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH } from '@fortawesome/pro-light-svg-icons';
import { PagePadding } from '../../Layout/MaxWidth';
import { useFilters } from '@jetshop/core/hooks/Filters/useFilters';
import { NumberBadge } from '../../ui/NumberBadge';
import { getFontSize } from '../../Theming/helpers';

const FilterWrapper = styled('div')`
  margin: 0 0;
  ${theme.above.lg} {
    border-top: 1px solid ${theme.colors.border};
    border-bottom: 1px solid ${theme.colors.border};
  }
`;

const MobileButtons = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: ${theme.colors.white};
  height: 38px;
  //transition: all 0.3s;
  > * {
    height: 100%;
    width: 48%;
  }
  .mobile-filter-button-wrapper {
    > button {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      padding: 0 0.5rem 0 0;
      svg {
        margin-right: 0.5rem;
        font-size: 1.5rem;
      }
      .number-badge {
        position: static;
        margin-left: 5px;
        background: ${theme.colors.primaryLight};
      }
    }
  }
  > div {
    min-width: 160px;
  }
  [data-flight-dropdown] {
    [data-flight-dropdown-button] {
      height: 38px;
      padding: 0 10px;
      border: 1px solid ${theme.colors.borderDark};
      &[aria-expanded='true'] {
        border-bottom: 1px solid ${theme.colors.white};
      }
    }
    [data-flight-dropdown-items] {
      border: 1px solid ${theme.colors.borderDark};
      border-top: none;
      width: 100%;
      min-width: auto;
      font-size: 0.9rem;
      [data-flight-dropdown-item]:focus {
        color: inherit;
      }
      [data-flight-dropdown-item]:first-child > div {
        border-top: 1px solid ${theme.colors.border};
      }
    }
  }
  &[data-scroll='true'] {
    position: fixed;
    height: 32px;
    padding: 0 ${theme.general.pagePadding.sm};
    top: ${theme.mobileHeader.height.scroll + 'px'};
    left: 0;
    width: 100%;
    z-index: 90;
    box-shadow: ${theme.general.boxShadow};
    .mobile-filter-button {
      padding: 0;
      background: none;
      color: ${theme.colors.font};
    }
    [data-flight-dropdown] {
      [data-flight-dropdown-button] {
        justify-content: flex-end;
        padding: 0;
        height: 32px;
        border: none;
        > svg {
          margin-left: 6px;
        }
      }
      [data-flight-dropdown-items] {
        top: 31px;
      }
    }
  }
`;

const DesktopFilter = styled('div')``;

const FilterStandard = styled('div')`
  display: flex;
  width: 100%;
  height: 60px;
  background: ${theme.colors.white};
  justify-content: flex-end;

  //FILTER ITEMS
  div.filters {
    flex-grow: 1;
    display: flex;
    > div {
      display: flex;
      &:not(:last-child),
      .bool-filter:not(:last-child) {
        margin-right: 2rem;
      }
    }
  }
  div.sorting {
    display: flex;
    > div,
    > div > div {
      display: flex;
    }
  }
  [data-flight-dropdown] [data-flight-dropdown-button] {
    > svg.carot {
      margin-left: 8px;
    }
  }
  .title {
    ${getFontSize(theme.categoryPage.filter.desktop.titles.fontSize)};
    font-family: ${theme.categoryPage.filter.desktop.titles.fontFamily};
    font-weight: ${theme.categoryPage.filter.desktop.titles.fontWeight};
    text-transform: ${theme.categoryPage.filter.desktop.titles.textTransform};
    letter-spacing: ${theme.categoryPage.filter.desktop.titles.letterSpacing};
    .filter-active-count {
      margin-left: 2px;
    }
  }
  &[data-scroll='true'] {
    position: fixed;
    width: 100%;
    left: 0;
    top: ${theme.desktopHeader.height.scroll + 'px'};
    box-shadow: ${theme.general.boxShadow};
    z-index: 90;
    padding: 0 1rem;
    > div {
      border-color: ${theme.colors.border};
      &:first-child {
        border-left: none;
      }
      &:last-child {
        border-right: none;
      }
    }
  }
`;

const ClearButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  button {
    width: 130px;
    font-size: 0.9rem;
    padding: 5px 10px;
    border: 1px solid ${theme.colors.border};
    height: 36px;
  }
`;

const Filter = ({ filters, sortOrders, result, setOnFilter }) => {
  const [scroll, setScroll] = useState(false);
  const { clearAllFilters } = useFilters();

  if (typeof window !== 'undefined' && window.scrollY === 0 && scroll)
    setScroll(false);

  useEffect(() => {
    return () => {
      if (typeof window !== 'undefined')
        window.removeEventListener('scroll', handleScroll);
    };
  });

  const handleScroll = event => {
    if (document.getElementById('filter-wrapper')) {
      const filterTop =
        document.getElementById('filter-wrapper').offsetTop -
        document.getElementById('main-header').offsetHeight;
      if (window.scrollY < filterTop && scroll) {
        setScroll(false);
      } else if (window.scrollY > filterTop && !scroll) {
        setScroll(true);
      }
    }
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', handleScroll);
  }

  const showFilter = filters && filters.length > 0;
  const showSorting = sortOrders && sortOrders.length > 0;

  const activeFilters = filters.filter(
    item => item.hasActiveItems || item.isActive || item.value
  ).length;

  const showResetButton = activeFilters > 0;

  if (!showFilter && !showSorting) return null;

  return (
    <FilterWrapper id="filter-wrapper" onClick={() => setOnFilter(true)}>
      <PagePadding>
        <Above breakpoint="lg">
          {matches =>
            matches ? (
              <DesktopFilter>
                {scroll && <FilterStandard />}
                <FilterStandard data-scroll={scroll}>
                  {showFilter && (
                    <div className="filters">
                      <ListFilters filters={filters} />
                      <RangeFilters filters={filters} />
                      <BooleanFilters filters={filters} />
                      {showResetButton && (
                        <ClearButtonWrapper>
                          <button onClick={clearAllFilters}>
                            {t('Clear all filters')}
                          </button>
                        </ClearButtonWrapper>
                      )}
                    </div>
                  )}
                  {showSorting && (
                    <div className="sorting">
                      <ListSorting sortOrders={sortOrders} />
                    </div>
                  )}
                </FilterStandard>
              </DesktopFilter>
            ) : (
              <Fragment>
                {scroll && <MobileButtons />}
                <MobileButtons data-scroll={scroll}>
                  <div className="mobile-filter-button-wrapper">
                    {showFilter && (
                      <DrawerTrigger
                        id="filterDrawer"
                        coverStyles={{ zIndex: 105 }}
                      >
                        {({ showTarget }) => (
                          <button
                            className="mobile-filter-button"
                            onClick={showTarget}
                          >
                            <FontAwesomeIcon icon={faSlidersH} />
                            {t('Filter')}
                            {activeFilters > 0 && (
                              <NumberBadge text={activeFilters} />
                            )}
                          </button>
                        )}
                      </DrawerTrigger>
                    )}
                  </div>
                  {showSorting && <ListSorting sortOrders={sortOrders} />}
                </MobileButtons>
                {showFilter && (
                  <DrawerTarget id="filterDrawer">
                    {({ hideTarget, isOpen }) => (
                      <Drawer isOpen={isOpen} left>
                        <FilterDrawer close={hideTarget} filters={filters} />
                      </Drawer>
                    )}
                  </DrawerTarget>
                )}
              </Fragment>
            )
          }
        </Above>
      </PagePadding>
    </FilterWrapper>
  );
};

export default Filter;
